import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Avatars from './pages/Avatars'
import AvatarDetails from './pages/AvatarDetails'
import Dialers from './pages/Dialers'
import DialerDetails from './pages/DialerDetails'
import Clients from './pages/Clients'
import ClientDetails from './pages/ClientDetails'
import Licenses from './pages/Licenses'
import Users from './pages/Users'
import VoiceSets from './pages/VoiceSets'
import KeywordCategories from './pages/KeywordCategories'
// KeywordSuggestions is now a tab in KeywordCategories
import Links from './pages/Links'
import Monitoring from './pages/MonitoringV2'
import MonitoringV3 from './pages/MonitoringV3'
import Servers from './pages/ServersV2'
import Templates from './pages/Templates'
import Machines from './pages/Machines'
import Stats from './pages/Stats'
import BackupStats from './pages/BackupStats'
import Financials from './pages/Financials'
import RequestInbox from './pages/RequestInbox'
import Issues from './pages/Issues'
import FieldTeamRoutes from './pages/FieldTeam'

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full" style={{ minHeight: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function AdminRoute({ children }) {
  const { isAdmin, isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full" style={{ minHeight: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return children
}

function App() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/" replace /> : <Login />
      } />

      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="stats" element={<Stats />} />
        <Route path="monitoring" element={<Monitoring />} />
        <Route path="monitoring-v3" element={<MonitoringV3 />} />
        <Route path="servers" element={<Servers />} />
        <Route path="avatars" element={<Avatars />} />
        <Route path="avatars/:id" element={<AvatarDetails />} />
        <Route path="dialers" element={<Dialers />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetails />} />
        <Route path="templates" element={<Templates />} />
        <Route path="machines" element={<Machines />} />
        <Route path="dialer-details/:id" element={<DialerDetails />} />
        <Route path="licenses" element={<Licenses />} />
        <Route path="users" element={
          <AdminRoute>
            <Users />
          </AdminRoute>
        } />
        <Route path="voice-sets" element={<VoiceSets />} />
        <Route path="keyword-categories" element={<KeywordCategories />} />
        <Route path="links" element={<Links />} />
        <Route path="backup-stats" element={<BackupStats />} />
        <Route path="financials" element={<Financials />} />
        <Route path="request-inbox" element={<RequestInbox />} />
        <Route path="issues" element={<Issues />} />
        <Route path="field-team/*" element={<FieldTeamRoutes />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App